import React from "react";

function UserPermissionWidget({ hasPermission, children }) {
  return <>{hasPermission ? children : null}</>;
}

export default UserPermissionWidget;
